export type CallEndedBy = 'worker' | 'remote';

/**
 * Who ended a human-operator call, as far as the browser can tell. The Voice
 * SDK fires the same `disconnect` event whether the operator clicked hang-up,
 * the other side hung up, or the leg failed, so the dialer has to remember
 * what it did itself.
 *
 * - operator clicked hang-up (or closed the dialer) → 'worker'
 * - clean disconnect with no local action and no SDK error → 'remote'
 * - anything else (error, reject, cancel) → undefined; the backend then
 *   reports "who ended the call was not recorded" rather than guessing.
 */
export function resolveCallEndedBy(params: {
  localHangUp: boolean;
  hadError: boolean;
}): CallEndedBy | undefined {
  if (params.localHangUp) return 'worker';
  if (!params.hadError) return 'remote';
  return undefined;
}

export interface CallStatusPayload {
  status: string;
  twilioCallSid?: string;
  endedBy?: CallEndedBy;
}

export function buildCallStatusPayload(
  status: string,
  options: { twilioCallSid?: string; endedBy?: CallEndedBy } = {},
): CallStatusPayload {
  const payload: CallStatusPayload = { status };
  if (options.twilioCallSid) payload.twilioCallSid = options.twilioCallSid;
  if (status === 'ended' && options.endedBy) payload.endedBy = options.endedBy;
  return payload;
}
